import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id 858F8782-5001-4950-96F2-65032091A847
 * name door
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/door.svg
 * tags
 * - Home Automation 
 */
export const DoorIcon = createSvgIcon(<><path d="M8,3C6.89,3 6,3.89 6,5V21H18V5C18,3.89 17.11,3 16,3H8M8,5H16V19H8V5M13,11V13H15V11H13Z" /></>, 'DoorIcon');
export default DoorIcon